import Button from '.';
import { Box } from '@xstyled/styled-components';
import { Bin } from '../Icons/SingleProduct';

export default function DeleteFavorite({ onClick }) {
  return (
    <Button
      display="flex"
      spaceX="0.5rem"
      whiteSpace="nowrap"
      onClick={onClick}
    >
      <span role="img" aria-label="Trash bin">
        {Bin}
      </span>
      <Box
        as="span"
        fontSize="14px"
        color="gray-200"
        display={{ _: 'inline-block', desktop: 'none' }}
      >
        Eemalda
      </Box>
    </Button>
  );
}
